import { STEPS } from "../data/steps";
import { redirectToSouscription } from "../helpers/souscription";
import { openZendeskWidget } from "../helpers/zendesk";
import { useZeroFranchiseTracking } from "../hooks/useZeroFranchiseTracking";
import { Button } from "./Button";
import { StepCard } from "./StepCard";

export const StepsSection = () => {
  const { trackOnlineSubscription, trackRecall } = useZeroFranchiseTracking();

  const handleSubscribe = () => {
    trackOnlineSubscription("etapes_fonctionnement");
    redirectToSouscription();
  };

  const handleRecall = () => {
    trackRecall("etapes_fonctionnement");
    openZendeskWidget();
  };

  return (
    <section
      className={[
        "flex flex-col items-center bg-[#0D0D0D]",
        "gap-10 px-4 py-20",
        "md:gap-14 md:px-20 md:py-24",
        "xl:px-20 xl:py-24",
      ].join(" ")}
    >
      <h2 className="text-center text-[23px] font-bold leading-[1.2] text-white md:text-[28px]">
        Comment ça marche ?
      </h2>

      <div className="flex w-full max-w-[560px] xl:max-w-[1440px] flex-col items-stretch gap-6 xl:flex-row">
        {STEPS.map((step) => (
          <StepCard key={step.id} step={step} />
        ))}
      </div>

      <div className="flex w-full max-md:max-w-[280px] flex-col items-stretch gap-4 md:w-auto md:flex-row">
        <Button variant="primary-yellow" onClick={handleSubscribe}>
          Souscrire en ligne
        </Button>
        <Button variant="outline-light" onClick={handleRecall}>
          Me faire rappeler
        </Button>
      </div>

      <div className="flex items-center gap-1 text-[#F2F2F2]">
        <img
          src="/assets/pack-zero-franchise/celebration.svg"
          alt=""
          width={20}
          height={20}
          className="block"
        />
        <p className="text-[16px] leading-[1.6]">Sans engagement, résiliable à tout moment</p>
      </div>
    </section>
  );
};
